var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"fade"}},[(_vm.showData.name)?_c('div',{class:{
    mask: _vm.noMask,
    transparent: !_vm.showData.mask,
  }},[(_vm.showData.name === 'tip')?_c('Tip',{attrs:{"popupData":_vm.showData.data}}):_vm._e(),_vm._v(" "),(_vm.showData.name === 'loading')?_c('Loading',{attrs:{"popupData":_vm.showData.data}}):_vm._e(),_vm._v(" "),(_vm.showData.name === 'fbbDialog')?_c('FbbDialog',{attrs:{"popupData":_vm.showData.data}}):_vm._e()],1):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-26dbe303","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/popup/Popup.vue
// module id = null
// module chunks = 